import {css} from '@emotion/core'
import styled from '@emotion/styled'
import {fontSize} from "@css/styles";
import {FontNormal} from "@css/fonts";
import {black, marketingMobileCuttoff} from "@css/constants";
import {Button} from "@components/Button";

export const LicenseTableContainer = styled('div')(css`
  max-width: 1070px;
  margin: 0 auto;
  padding-left: 15px;
  padding-right: 15px;
`);

export const StyledTable = styled('table')(css`
  margin: 50px auto;
  max-width: 1000px;
  table-layout: fixed;
  border-collapse: collapse;
  border-spacing: 0;
  color: #666;
  
  @media(max-width: ${marketingMobileCuttoff}) {
    display: none;
  }
`);

export const StyledTHead = styled('thead')(css`
  background-color: #f5f5f5;

  & > tr {
    & > th {
      border-bottom: 2px solid #ddd;
    }
  }
`);

export const StyledTh = styled('th')(css`
  vertical-align: middle;
  text-align: center;
  padding: 8px;
  ${fontSize(14)}
  ${FontNormal(400)}
`);

export const StyledTd = styled('td')(css`
  vertical-align: middle;
  text-align: center;
  padding: 8px;
  ${fontSize(14)};
  ${FontNormal(400)};
  border: 1px solid whitesmoke;
`);

export const LicenseTr = styled('tr')(css`
  padding: 10px;
  margin: 0px auto;
  position: relative;
`);

export const StateTd = styled(StyledTd)(css`
  width: 75px;
  ${FontNormal(600)}
`);

export const NumberTd = styled(StyledTd)(css`
  width: 150px;
`);

export const InstructionTd = styled(StyledTd)(css`
  max-width: 325px;
  text-align: left;
`);

export const UrlTd = styled(StyledTd)(css`
  word-wrap: break-word;
  max-width: 350px;
  text-align: left;
  
  & > a {
    color: #5ecd82;
  }
`);

export const StyledA = styled('a')(css`
  ${FontNormal(400)};
`);

export const ImageTd = styled(StyledTd)(css`
  width: 100px;
  img {
    max-width: 50px;
  }
`);

export const LicenseMobile = styled('div')(css`
  display: none;
  
  @media(max-width: ${marketingMobileCuttoff}) {
    display: block;
  }
`);

export const LicenseWrapper = styled('div')(css`
    color: #666666;
    padding: 15px;
    border-bottom: 1px solid whitesmoke;
`);

export const LicenseWrapperPreview = styled('div')(css`
  display: flex;
  align-items: center;
  position: relative;
`);

export const LicenseImage = styled('div')(css`
  img {
    max-width: 50px;
  }
`);

export const LicenseInfo = styled('div')(css`
  padding-left: 25px;
`);

export const LicenseState = styled('h5')(css`
  width: 75px;
  ${FontNormal(600)};
  color: ${black};
`);

export const LicenseNumber = styled('span')(css`
  ${FontNormal(400)};
  width: 150px;
`);

export const LicenseContent = styled('div')(css`
  ${fontSize(12)};
  ${FontNormal(400)};
  height: auto;
  margin-top: 20px;
  margin-bottom: 20px;
`);

export const BoldSpan = styled('span')(css`
  ${FontNormal(600)};
  color: #666;
`);

export const StyledP = styled('div')(css`
  margin-bottom: 15px;
  ${FontNormal(400)};

  & > a {
    ${FontNormal(400)};
    color: #5ecd82;
  }
`)

export const ViewLicenseButton = styled(Button)(css`
  background-color: #5ecd82;
  box-shadow: none;
`)

